import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../PrintStyles.css'; // File CSS khusus print

const columnLabels = {
  NoNota: 'No Nota',
  KodeReferensi: 'Kode Referensi',
};

const NotaPreview = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { filteredData = [], selectedColumns = [], fromDate = '', toDate = '', lokasi = '' } = location.state || {};

  const leftTable = filteredData.slice(0, 15);
  const rightTable = filteredData.slice(15);

  const displayColumns = ['NoNota', 'KodeReferensi', ...selectedColumns.filter((col) => !['NoNota', 'KodeReferensi'].includes(col))];

  const renderTable = (dataSlice, startIndex) => (
    <table className="w-full text-xs border border-black mb-4">
      <thead>
        <tr className="bg-gray-200">
          <th className="border border-black px-2 py-1">No</th>
          {displayColumns.map((col) => (
            <th key={col} className="border border-black px-2 py-1">
              {columnLabels[col] || col}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {dataSlice.map((row, idx) => (
          <tr key={idx}>
            <td className="border border-black px-2 py-1">{startIndex + idx + 1}</td>
            {displayColumns.map((col) => (
              <td key={col} className="border border-black px-2 py-1">
                {row[col] ?? '-'}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );

  if (!filteredData.length) {
    return (
      <div className="p-8 text-center">
        <p className="text-lg text-gray-700 mb-4">Tidak ada data untuk ditampilkan.</p>
        <button onClick={() => navigate(-1)} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
          Kembali ke halaman filter
        </button>
      </div>
    );
  }

  return (
    <div
      className="a4-paper bg-white text-black min-h-screen 
                    pl-64 pt-10 p-8 mx-auto print:pl-0 print:pt-0 print:p-10 print:m-0 print:bg-white"
    >
      <h1 className="text-2xl font-bold text-center mb-4">SERAH TERIMA NOTA</h1>

      <div className="mb-4 text-sm space-y-1">
        <div>
          <span className="font-semibold">Tanggal</span>: {fromDate} s.d. {toDate}
        </div>
        <div>
          <span className="font-semibold">Lokasi</span>: {lokasi}
        </div>
      </div>

      <p className="font-semibold text-sm mb-2">Dokumen yang diambil:</p>
      <div className="table-container">
        <div>{renderTable(leftTable, 0)}</div>
        <div>{renderTable(rightTable, 15)}</div>
      </div>

      <div className="flex justify-between mt-16 text-sm">
        <div className="text-center w-1/2">
          <p className="font-semibold mb-6">Pemberi</p>
          <div className="h-24 border-t border-black w-3/4 mx-auto" />
          <p className="mt-2">(Nama)</p>
          <p className="mt-1">Tanggal: ..............</p>
        </div>
        <div className="text-center w-1/2">
          <p className="font-semibold mb-6">Penerima</p>
          <div className="h-24 border-t border-black w-3/4 mx-auto" />
          <p className="mt-2">(Nama)</p>
          <p className="mt-1">Tanggal: ..............</p>
        </div>
      </div>

      <div className="mt-8 flex justify-end print:hidden">
        <button onClick={() => navigate(-1)} className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 mr-2">
          Kembali
        </button>
        <button onClick={() => window.print()} className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700">
          Cetak
        </button>
      </div>
    </div>
  );
};

export default NotaPreview;
